import LeftGroupList from "@/components/LeftGroupList";
import api from "@/api";
import TextLogicalReasoningQuestion from "@/components/subject/TextLogicalReasoning/TextLogicalReasoningQuestion.vue";
export default {
  name: "TextLogicalReasoningQuestionSelector",
  components: {
    TextLogicalReasoningQuestion,
    LeftGroupList
  },
  data() {
    return {
      groups: [],
      groupId: null,
      questions: []
    };
  },
  methods: {
    confirm(qid) {
      this.$emit('confirm', qid);
    },
    onChoose(gid) {
      this.groupId = gid;
      this.fetchList();
    },
    fetchList() {
      api.getTextLogicalQuestionByGroupId(this.groupId, true).then(ret => {
        this.questions = ret.list;
      });
    },
    init() {
      api.getTextLogicalGroups().then(list => {
        this.groups = list;
        this.groupId = list[0]?.value || null;
        if (this.groupId) this.fetchList();
      });
    }
  },
  mounted() {
    this.init();
  }
};